import { Grid, Paper, Typography, SvgIcon } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { newDocumentPath, useCreatableDocumentTypes } from "../../utils/medicalDocument/documentTypes";

const homeCardsByBasePath = {
  prescriptions: {
    title: "Recetas",
    description: "Desde aqui vas a poder generar una nueva prescripción o duplicado.",
    img: "/bg-recetas.png",
  },
  orders: {
    title: "Ordenes",
    description: "Desde aqui vas a poder generar una nueva orden, licencia o certificado médico.",
    img: "/bg-ordenes.png",
  },
};

export default function NewOrderAndNewPrescription() {
  const navigator = useNavigate();
  const creatableDocumentTypes = useCreatableDocumentTypes();

  return (
    <Grid container spacing={5}>
      {creatableDocumentTypes.map((documentType) => {
        const { title, description, img } = homeCardsByBasePath[documentType.basePath];

        return (
          <Grid item xs={12} sm={12} md={6} lg={6} xl={5} key={documentType.basePath}>
            <Paper
              onClick={() => navigator(newDocumentPath(documentType))}
              sx={{
                cursor: "pointer",
                height: "220px",
                borderRadius: 5,
                p: 4,
                color: "#FFFFFF",
                backgroundImage: `url(${img})`,
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                "&:hover": { boxShadow: 1, backgroundImage: `linear-gradient(#00000010, #00000010), url(${img})` },
              }}
            >
              <Grid item xs={12} sm={12} md={12} lg={8}>
                <SvgIcon color="white" sx={{ fontSize: 40, ml: -1 }}>
                  <documentType.Icon />
                </SvgIcon>
                <Typography color="white" sx={{ fontSize: "28px", fontWeight: 600, mt: 1 }}>
                  {title}
                </Typography>
                <Typography color="white" sx={{ fontSize: "16px", mt: 1 }}>
                  {description}
                </Typography>
              </Grid>
            </Paper>
          </Grid>
        );
      })}
    </Grid>
  );
}
